import StrategicPlanList from "../components/StrategicPlanList";

const ListStrategicPlanPage = () => {
  return (
    <StrategicPlanList />
  );
};

export default ListStrategicPlanPage;
